import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { getAuthGuardDecision, getLoginReturnPath } from './authGuard';

export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const { isInitialized, isLoggedIn } = useAuth();
  const location = useLocation();
  const decision = getAuthGuardDecision(isInitialized, isLoggedIn);
  if (decision === 'pending') {
    return null;
  }
  if (decision === 'redirect') {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: getLoginReturnPath(location.pathname, location.search) }}
      />
    );
  }
  return <>{children}</>;
}
